import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  aboutUsApi,
  astrologerTermsPrivacyApi,
  socialLinksApi,
  termsPrivacyApi,
} from "../../../routes/apiRoutes";
import axios from "axios";
import {
  ABOUT_US,
  ASTROLOGER_TERMS_PRIVACY,
  SOCIAL_LINKS,
  TERMS_PRIVACY,
} from "../../../redux/actions";

export const termsPrivacyMiddleWare = createAsyncThunk(
  TERMS_PRIVACY,
  async (_a, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(termsPrivacyApi);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const aboutUsMiddleWare = createAsyncThunk(
  ABOUT_US,
  async (_a, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(aboutUsApi);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const astrologerTermsPrivacyMiddleWare = createAsyncThunk(
  ASTROLOGER_TERMS_PRIVACY,
  async (_a, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(astrologerTermsPrivacyApi);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const socialLinksMiddleWare = createAsyncThunk(
  SOCIAL_LINKS,
  async (_a, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(socialLinksApi);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
